"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectorGenerator = exports["default"] = exports.GenerateState = void 0;

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
} // const objectToCSSString = (selector, styleObject) => `${selector} {
//   ${Object.entries(styleObject).map(([style, value2]) => `${style}: ${value2}`).join(';')}
// }`;


var selectorGenerator = function selectorGenerator(key, className) {
  switch (key) {
    case "unselected":
      return ".".concat(className);

    case "selected":
      return ".".concat(className, ":active");

    case "disabled":
      return ".".concat(className, ":disabled");

    default:
      return "";
  }
};

exports.selectorGenerator = selectorGenerator;

var GenerateState = /*#__PURE__*/function () {
  function GenerateState(state) {
    var _this = this;

    _classCallCheck(this, GenerateState);

    this.handleStyle = function (theme, property, selector, style) {
      if (style === null) {
        var _this$stateStylings$d;

        return (_this$stateStylings$d = _this.stateStylings.disabled[property]) !== null && _this$stateStylings$d !== void 0 ? _this$stateStylings$d : "transparent";
      }

      return "#".concat(theme.colors[style]);
    };

    this.stateStylings = state || {
      disabled: {},
      selected: {},
      unselected: {}
    };
  }

  _createClass(GenerateState, [{
    key: "val",
    get: function get() {
      return this.stateStylings;
    }
  }, {
    key: "generateWidthState",
    value: function generateWidthState(_ref) {
      var property = _ref.property,
          value = _ref.value;
      if (value === (undefined || null)) return this;
      this.stateStylings = {
        disabled: _objectSpread(_objectSpread({}, this.stateStylings.disabled), {}, _defineProperty({}, property, _typeof(value) === "object" ? "".concat(value.disabled, "px") : "".concat(value || 0, "px"))),
        selected: _objectSpread(_objectSpread({}, this.stateStylings.selected), {}, _defineProperty({}, property, _typeof(value) === "object" ? "".concat(value.selected, "px") : "".concat(value || 0, "px"))),
        unselected: _objectSpread(_objectSpread({}, this.stateStylings.unselected), {}, _defineProperty({}, property, _typeof(value) === "object" ? "".concat(value.unselected, "px") : "".concat(value || 0, "px")))
      };
      return this;
    }
  }, {
    key: "generateColorState",
    value: function generateColorState(_ref2) {
      var theme = _ref2.theme,
          property = _ref2.property,
          value = _ref2.value;
      if (value === undefined) return this;
      this.stateStylings = {
        disabled: value === null ? _objectSpread(_objectSpread({}, this.stateStylings.disabled), {}, _defineProperty({}, property, "transparent")) : _objectSpread(_objectSpread({}, this.stateStylings.disabled), {}, _defineProperty({}, property, _typeof(value) === "object" ? this.handleStyle(theme, property, "disabled", value.disabled) : "#".concat(theme.colors[value]))),
        selected: value === null ? _objectSpread(_objectSpread({}, this.stateStylings.selected), {}, _defineProperty({}, property, "transparent")) : _objectSpread(_objectSpread({}, this.stateStylings.selected), {}, _defineProperty({}, property, _typeof(value) === "object" ? this.handleStyle(theme, property, "selected", value.selected) : "#".concat(theme.colors[value]))),
        unselected: value === null ? _objectSpread(_objectSpread({}, this.stateStylings.unselected), {}, _defineProperty({}, property, "transparent")) : _objectSpread(_objectSpread({}, this.stateStylings.unselected), {}, _defineProperty({}, property, _typeof(value) === "object" ? this.handleStyle(theme, property, "unselected", value.unselected) : "#".concat(theme.colors[value])))
      };
      return this;
    }
  }, {
    key: "generateCommonState",
    value: function generateCommonState(_ref3) {
      var property = _ref3.property,
          value = _ref3.value;
      this.stateStylings = {
        disabled: _objectSpread(_objectSpread({}, this.stateStylings.disabled), {}, _defineProperty({}, property, _typeof(value) === "object" ? value.disabled : value)),
        selected: _objectSpread(_objectSpread({}, this.stateStylings.selected), {}, _defineProperty({}, property, _typeof(value) === "object" ? value.selected : value)),
        unselected: _objectSpread(_objectSpread({}, this.stateStylings.unselected), {}, _defineProperty({}, property, _typeof(value) === "object" ? value.unselected : value))
      };
      return this;
    }
  }, {
    key: "generateBorderState",
    value: function generateBorderState(_ref4) {
      var theme = _ref4.theme,
          value = _ref4.value;

      if (value === null) {
        return this;
      }

      this.stateStylings = this.generateWidthState({
        property: "border-width",
        value: value.width
      }).generateColorState({
        theme: theme,
        property: "border-color",
        value: value.colors
      }).generateCommonState({
        property: "border-style",
        value: value.style || "solid"
      }).val;
      return this;
    }
  }]);

  return GenerateState;
}();

exports.GenerateState = GenerateState;
var _default = {
  GenerateState: GenerateState,
  selectorGenerator: selectorGenerator
};
exports["default"] = _default;